import styled from "styled-components";

interface IDialogBase {
  show: boolean;
}

export const DialogBase = styled.form<IDialogBase>`
  transition: all 0.2s ease-in-out;

  opacity: ${({ show }) => (show ? "1" : "0")};
  pointer-events: ${({ show }) => (show ? "all" : "none")};
  transform: ${({ show }) => (show ? "translateX(0)" : "translateX(10px)")};
  background-color: ${({ theme }) => theme.groups.backgroundComponentsMural};
  box-shadow: inset 0px 0px 0px 2px
    ${({ theme }) => theme.groups.borderColorComponentsMural};

  border-radius: 4px;

  position: absolute;
  right: 0.3rem;
  z-index: 9999;

  top: 5rem;
  padding: 0.75rem;

  width: 100vw;
  max-width: fit-content;

  display: flex;
  gap: 0.75rem;
  flex-direction: column;

  @media (min-width: 600px) {
    top: 3.5rem;
  }
`;
